var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"mainCont"},[_c('el-aside',{attrs:{"width":"200px"}},[_c('navs')],1),_c('el-container',[_c('el-header',{attrs:{"height":"60px"}},[_c('toper')],1),_c('el-main',{attrs:{"height":"100%"}},[_c('transition',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }